import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MonitorService } from './monitor.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ToastService {

  private toastrTranslation = {};

  constructor(private toastr: ToastrService, private translate: TranslateService, private monitorService: MonitorService) {
    this.translate.stream('TOASTRS').subscribe(
      (translated) => {
        this.toastrTranslation = translated;
      });
  };

  error(source, context, msg = this.toastrTranslation['DEFAULT_FAILED_TO_SAVE'], errorDetails = null, reportError = true) {
    if (reportError) {
      const additionalAttributes = { context: context, errorDetails: errorDetails };
      this.monitorService.reportError(msg, 'toasterService', source, additionalAttributes);
    }
    return this.toastr.error(msg , this.toastrTranslation['DEFAULT_ERROR']);
  }

  success(msg = this.toastrTranslation['DEFAULT_SAVED_SUCCESSFULLY']) {
    return this.toastr.success(msg , null);
  }

  errorNoTitle(msg = this.toastrTranslation['DEFAULT_SAVED_SUCCESSFULLY']) {
    return this.toastr.error(msg , null);
  }
}

